import "../../styles/SectionFood.css"
import {getIcon, smoothScrollToId} from "../../utils/helper";

const SectionFood = () => {
    const handleOpenNewTab = () => {
        if (window) {
            window.open('https://d-gastro24.de/order/hamirestaurant', '_blank', 'noopener,noreferrer');
        }
    };
    const handleOpenScroll = () => {
        smoothScrollToId('tisch-reservieren')
    }
    return (
        <section className="section about text-center" aria-labelledby="dish-label">
            <div className="container">
                <div className="special-dish-banner">
                    <img src="/assets/images/special-dish-banner.jpg" loading="lazy"
                         alt="special dish" className="img-cover"/>
                </div>

                <div className="about-content">
                    <div className="wrap-title">
                        <div className="icon-title">
                            <img src="/assets/images/badge-1.png" width="28" height="41" loading="lazy" alt="badge"
                                 className=" "/>
                        </div>
                        <div className="title">
                            <p className="label-2 section-subtitle slider-reveal">Our Story</p>
                            <div className="icon-separator">
                                {getIcon("separator")}
                            </div>
                        </div>
                    </div>
                    <h2 className="headline-1 section-title">
                        2. Die kreative Reise von Ha Mi
                    </h2>
                    <div className="section-text">
                        <p>
                            Ha Mi entstand aus der Leidenschaft für kulinarische Entdeckungen und Kreativität. Mit dem
                            Wunsch, frischen Wind in den Alltag zu bringen, kombinieren wir frische Zutaten und
                            traditionelle Rezepte mit modernen Kochtechniken und Elementen aus verschiedenen Küchen der
                            Welt.
                        </p>
                        <p>
                            Von japanisch inspiriertem vegetarischem Phở über Fusionsgerichte bis hin zu Nudelgerichten,
                            die
                            europäische und asiatische Gewürze vereinen – jedes Gericht bei Ha Mi ist eine Reise, die
                            das
                            Zusammenspiel von Tradition und Moderne erlebbar macht.
                        </p>
                    </div>
                    <div className="section-text">
                        Ansprechpartner: Ronny Löser
                    </div>
                    <div className="wrapBtn">
                        {/*<button onClick={handleOpenNewTab} type="button" className={`btnSecondary btn`}>*/}
                        {/*    <span className={`text text1`}>Online bestellen</span>*/}
                        {/*    <span className={`text text2`} aria-hidden="true">Online bestellen</span>*/}
                        {/*</button>*/}
                        <button onClick={handleOpenScroll} type="button" className={`btnSecondary btn`}>
                            <span className={`text text1`}>Tisch reservieren</span>
                            <span className={`text text2`} aria-hidden="true">Tisch reservieren</span>
                        </button>
                    </div>


                </div>
            </div>
            {/*<img src="assets/images/shape-4.png" width="179" height="359" loading="lazy" alt=""*/}
            {/*     className="shape shape-1"/>*/}

            <img src="/assets/images/shape-9.png" loading="lazy" alt=""
                 className="shape shape-9"/>

        </section>
    )
}
export default SectionFood